import {lazy} from "react";

export const TrackAdvancedGroupLazy = lazy(()=>import('./TrackAdvancedGroup'))